<template>
  <div class="filter-page">
    <!-- 筛选按钮 -->
    <div class="filter-header">
      <div class="filter-btn" @click="closepop()">
        <span>{{ currentLabel ||keywords }}</span>
        <img style="width: 20px;height: 20px;" src="../images/down.png" alt="">
      </div>
      <!-- <div class="filter-right" @click="showPriceFilter = true;showFilter=false">
        <img 
          style="width: 35px; height: 35px;" 
          src="../images/rightopen.png" 
          alt="价格筛选"
        >
      </div> -->
    </div>

    <!-- 筛选弹出层 -->
    <div class="popup-menu" v-if="showFilter">
      <div class="menu-content">
        <div class="menu-header">
          <!-- <div class="close-btn" >×</div> -->
        </div>
        <div class="menu-list">
          <div 
            v-for="(item, index) in category_list" 
            :key="index"
            class="menu-item"
            @click="selectFilter(item.value,index)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>

    <!-- 修改价格筛选面板，使用普通 div 替代 van-popup -->
    <div class="price-filter-panel" v-show="showPriceFilter">
      <div class="price-filter">
        <div class="price-header">
          <span class="title">价格</span>
          <div class="close-btn" @click="showPriceFilter = false">×</div>
        </div>

        <!-- 自定义价格输入 -->
        <div class="custom-price">
          <input 
            type="number" 
            v-model="minPrice" 
            placeholder="自定义最低价"
            class="price-input"
          >
          <span class="separator">-</span>
          <input 
            type="number" 
            v-model="maxPrice" 
            placeholder="自定义最高价"
            class="price-input"
          >
        </div>

        <!-- 预设价格区间 -->
        <div class="price-ranges">
          <div 
            v-for="range in priceRanges" 
            :key="range.value"
            class="range-item"
            :class="{ active: currentRange === range.value }"
            @click="selectRange(range)"
          >
            {{ range.label }}
          </div>
        </div>

        <!-- 重置和确定按钮 -->
        <div class="price-actions">
          <div class="reset-btn" @click="resetPrice">重置</div>
          <div class="confirm-btn" @click="confirmPrice">确定</div>
        </div>
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="goods-list">
      <!-- 有数据时显示商品网格 -->
      <div class="goods-grid" v-if="goods_list.length > 0">
        <div 
          v-for="(item, index) in goods_list" 
          :key="index"
          class="goods-item"
          @click="goDetail(item.id)"
        >
          <img :src="item.home_recommended_images" :alt="item.title">
          <div class="goods-info">
            <div class="goods-title">{{ item.title }}</div>
            <div class="goods-price"> <span class="rmb">¥ </span> {{ item.min_price }}</div>
          </div>
        </div>
      </div>
      
      <!-- 无数据时显示空状态 -->
      <div class="empty-state" v-else>
        <van-empty
          class="custom-empty"
          image="search"
          :description="getEmptyText()"
        >
          <template #bottom>
            <div class="empty-tip">试试其他分类或搜索关键词</div>
          </template>
        </van-empty>
      </div>
      
      <!-- 修改分页器 -->
      <div class="pagination" v-if="total > 0">
        <van-pagination 
          v-model="page" 
          @change="handlePageChange" 
          :total-items="total" 
          :page-count="page_total"
          force-ellipses
        >
          <template #prev-text>
            <van-icon name="arrow-left" color="#333333" />
          </template>
          <template #next-text>
            <van-icon name="arrow" color="#333333" />
          </template>
          <template #page="{ text }" color="#333333">{{ text }}</template>
        </van-pagination>
      </div>
    </div>
    <v-foot></v-foot>
  </div>
</template>

<script>
import { Pagination } from 'vant';

export default {
  components: {
    [Pagination.name]: Pagination
  },
  data() {
    return {
      showFilter: false,  // 控制筛选弹出层
      filterItems: [
        { label: '全部', value: 'all' },  // 添加全部选项
        { label: '连衣裙', value: 'dress' },
        { label: 'T恤', value: 'tshirt' },
        { label: '针织', value: 'knitwear' },
        { label: '裤子', value: 'pants' },
        { label: '衬衫', value: 'shirt' },
        { label: '半身裙', value: 'skirt' },
        { label: '外套', value: 'coat' }
      ],
      category_list:[],
      category_id: 0,
      keywords: '',
      page: 1,
      total: 0,        // 总数据量
      page_total: 0,   // 总页数
      pageSize: 8,     // 每页显示数量
      loading: false,
      showPriceFilter: false,
      minPrice: '',
      maxPrice: '',
      currentRange: '',
      priceRanges: [
        { label: '0-100', value: '0-100', min: 0, max: 100 },
        { label: '100-200', value: '100-200', min: 100, max: 200 },
        { label: '200-300', value: '200-300', min: 200, max: 300 }
      ],
      currentLabel: '', // 当前选中的标签名
      selectedIndex: 0, // 添加选中的索引
      currentFilter: '', // 添加当前选中的筛选值
      goods_list: [], // 添加商品列表数组
    }
  },
  created() {
    // 从路由参数获取搜索关键词
    const { keywords } = this.$route.query;
    
    // 处理关键词
    this.keywords = keywords || '';
    
    // 获取数据
    this.getFilteredData();
    const url = "api/search/index";
      const data = {
        category_id: 0,
        keywords: '',  // 不使用关键词
        page: 1
      };
      
      console.log('获取所有分类 - 请求参数:', data);
      
      this.POST(url, data, (ret) => {
        if (ret.code === 0) {
          // 保存分类列表
          if (ret.data.category && ret.data.category.length > 0) {
            this.category_list = ret.data.category;
          }
          
          // 保存商品列表，确保有数据显示
          if (ret.data.data && ret.data.data.length > 0) {
            this.goods_list = ret.data.data;
            this.total = ret.data.total || 0;
            this.page_total = ret.data.page_total || 0;
          }
          
          // 如果没有设置当前标签，自动选择第一项
          if ((!this.currentLabel || this.currentLabel === '') && 
              this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[this.selectedIndex].text;
          }
          
          console.log('获取所有分类成功:', {
            分类列表长度: this.category_list.length,
            当前标签: this.currentLabel,
            商品列表长度: this.goods_list.length
          });
        } else {
          console.error('获取所有分类失败');
        }
        this.loading = false;
      });
      this.trackPageView()
  },
  watch: {
    // 监听分类列表变化，自动设置默认选中项
    category_list: {
      handler(newList) {
        if (newList && newList.length > 0) {
          // 如果是首次加载或显示全部，选中第一项
          if (!this.currentLabel || this.$route.query.showAll) {
            // this.selectedIndex = 0; // 默认选中第一项
            this.currentLabel = newList[this.selectedIndex].text;
            
            // 如果是显示全部的情况，设置category_id为0
            if (this.$route.query.showAll) {
              this.category_id = 0;
            }
          }
        }
      },
      immediate: true
    },
    
    // 修改关键词监听器
    keywords: {
      handler(newKeywords) {
        // 检查是否是从搜索页面跳转来的
        const isFromSearch = this.$route.query.fromSearch;
        
        if (!newKeywords) {
          // 如果关键词为空且有分类列表，选中第一项
          if (this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[this.selectedIndex].text;
            this.category_id = 0;
          }
        } else if (!isFromSearch) {
          // 只有不是从搜索页面来的关键词才匹配筛选项
          const matchedItem = this.filterItems.find(item => 
            item.label === newKeywords
          );
          
          if (matchedItem) {
            this.currentLabel = matchedItem.label;
            this.category_id = matchedItem.value;
          }
        } else {
          // 如果是搜索关键词，选中第一项
          if (this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[this.selectedIndex].text;
            this.category_id = 0;
          }
        }

      },
      immediate: true
    },
    // 监听路由参数变化
    '$route.query': {
      handler(newQuery) {
        // 更新关键词
        this.keywords = newQuery.keywords || '';
        // 处理显示全部的情况
        if (newQuery.showAll) {
          this.category_id = 0;
          
          // 确保有分类列表
          if (!this.category_list || this.category_list.length === 0) {
            this.getCategoryList();
          } else if (this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[0].text;
          }
        }
        
        // 重置页码并重新获取数据
        this.page = 1;
        this.getFilteredData();
      },
      deep: true
    }
  },
  methods: {
    trackPageView() {
                const url = 'api/agreement/maidian?type=category';
                
                this.GET(url, null, (response) => {
                    console.log('埋点数据上报成功:', response);
                });
    },
    closepop(){
      this.showPriceFilter=false
      this.showFilter = !this.showFilter
    },
    // 修改获取数据的方法
    getFilteredData() {
      this.loading = true;
      const url = "api/search/index";
      
      // 检查是否是从全部分类进入
      const isShowAll = this.$route.query.showAll;
      
      // 如果是显示全部，清空关键词
      const keywords = isShowAll ? '' : this.keywords;
      
      const data = {
        category_id: this.category_id || 0,
        keywords: keywords,
        page: this.page
      };


      this.POST(url, data, (ret) => {
        if (ret.code === 0) {
          // 保存商品列表数据
          this.goods_list = ret.data.data || [];
          this.total = ret.data.total || 0;
          this.page_total = ret.data.page_total || 0;
          
          // 确保分类列表不为空
          if (ret.data.category && ret.data.category.length > 0) {
            this.category_list = ret.data.category;
          } else {
            // 如果分类列表为空，重新获取所有分类
            this.getCategoryList();
            return; // 提前返回，避免重复设置
          }
          
          // 如果没有设置当前标签，自动选择第一项
          if ((!this.currentLabel || this.currentLabel === '') && 
              this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[this.selectedIndex].text;
            console.log('数据加载后设置默认标签:', {
              索引: this.selectedIndex,
              标签: this.currentLabel
            });
          }
          
          // 检查是否有搜索结果
          if (this.goods_list.length === 0 && keywords) {
            console.log('搜索无结果，1秒后加载所有数据');
            
            // 显示提示
            this.$toast({
              message: '未找到相关商品，即将显示所有商品',
              position: 'bottom',
              duration: 1000
            });
            
            // 1秒后加载所有数据
            setTimeout(() => {
              this.keywords = '';
              this.category_id = 0;
              
              // 更新路由参数
              this.$router.replace({ 
                path: this.$route.path, 
                query: { showAll: true }
              }).catch(() => {});
              
              // 重新获取所有数据
              this.getCategoryList();
            }, 100);
          }
          
          console.log('分页数据:', {
            当前页: this.page,
            总页数: this.page_total,
            总数据量: this.total,
            每页数量: this.pageSize,
            当前标签: this.currentLabel,
            分类列表长度: this.category_list ? this.category_list.length : 0,
            商品列表长度: this.goods_list.length
          });
        } else {
          this.goods_list = [];
          this.total = 0;
          this.page_total = 0;
          console.error('获取数据失败:', ret.msg);
          
          // 如果搜索失败，1秒后尝试获取所有分类
          setTimeout(() => {
            this.getCategoryList();
          }, 1000);
        }
        this.loading = false;
      });
    },
    
    // 修改获取所有分类的方法
    getCategoryList() {
      const url = "api/search/index";
      const data = {
        category_id: 0,
        keywords: '',  // 不使用关键词
        page: 1
      };
      
      console.log('获取所有分类 - 请求参数:', data);
      
      this.POST(url, data, (ret) => {
        if (ret.code === 0) {
          // 保存分类列表
          if (ret.data.category && ret.data.category.length > 0) {
            this.category_list = ret.data.category;
          }
          
          // 保存商品列表，确保有数据显示
          if (ret.data.data && ret.data.data.length > 0) {
            this.goods_list = ret.data.data;
            this.total = ret.data.total || 0;
            this.page_total = ret.data.page_total || 0;
          }
          
          // 如果没有设置当前标签，自动选择第一项
          if ((!this.currentLabel || this.currentLabel === '') && 
              this.category_list && this.category_list.length > 0) {
            this.selectedIndex = 0;
            this.currentLabel = this.category_list[this.selectedIndex].text;
          }
          
          console.log('获取所有分类成功:', {
            分类列表长度: this.category_list.length,
            当前标签: this.currentLabel,
            商品列表长度: this.goods_list.length
          });
        } else {
          console.error('获取所有分类失败');
        }
        this.loading = false;
      });
    },

    // 修改分页方法
    handlePageChange(page) {
      this.page = page;
      this.getFilteredData();
      
      // 滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    // 修改筛选方法
    selectFilter(value, index) {
      this.keywords=''
      this.selectedIndex = index; // 保存选中的索引
      this.category_id = value || 0;
      
      this.page = 1;
      this.getFilteredData();
      // 使用 nextTick 确保在 DOM 更新后再次设置标签
      this.$nextTick(() => {
        if (this.category_list && this.category_list.length > index) {
          this.currentLabel = this.category_list[index].text;
        }
      });
      
      this.showFilter = false;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    // 修改搜索方法
    handleSearch(keywords) {
      console.log('搜索关键词:', keywords);
      
      // 更新关键词
      this.keywords = keywords || '';
      
      // 重置页码
      this.page = 1;
      
      // 更新路由参数，但不触发路由变化
      const query = { ...this.$route.query, keywords: this.keywords, showAll: false };
      this.$router.replace({ 
        path: this.$route.path, 
        query 
      }).catch(() => {});
      
      // 显示加载中
      this.loading = true;
      
      // 重新获取数据
      this.getFilteredData();
    },

    // 修改跳转详情页的方法
    goDetail(id) {
      this.$router.push({
        path: '/details', // 添加前导斜杠
        query: { id }
      })
    },
    // 获取空状态提示文字
    getEmptyText() {
      if (this.keywords && this.currentLabel) {
        return `未找到与"${this.keywords}"相关的${this.currentLabel}商品`;
      } else if (this.keywords) {
        return `未找到与"${this.keywords}"相关的商品`;
      } else if (this.currentLabel) {
        return `暂无${this.currentLabel}相关商品`;
      }
      return '暂无相关商品';
    },
    selectRange(range) {
      this.currentRange = range.value;
      this.minPrice = range.min;
      this.maxPrice = range.max;
    },
    resetPrice() {
      this.minPrice = '';
      this.maxPrice = '';
      this.currentRange = '';
    },
    confirmPrice() {
      const min = Number(this.minPrice);
      const max = Number(this.maxPrice);
      
      if (min > max) {
        this.$toast('最低价不能大于最高价');
        return;
      }

      // 添加价格筛选参数
      this.price_min = min;
      this.price_max = max;
      this.page = 1; // 重置到第一页
      
      // 重新获取数据
      this.getFilteredData();
      this.showPriceFilter = false;
    }
  }
}
</script>

<style scoped>
.filter-page {
  min-height: 100vh;
  background: #fff;
}

.filter-header {
  position: sticky;
  top: 70px;
  z-index: 99;
  background: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size:18px;
  color: #333;
  font-weight: bold;
  font-family: Songti SC, Songti SC;
  cursor: pointer;
}

.filter-right {
  cursor: pointer;
  transition: opacity 0.3s;
}

.filter-right:hover {
  opacity: 0.8;
}

.filter-btn .van-icon {
  margin-left: 5px;
  font-size: 12px;
}

.popup-menu {
  position: fixed;
  top: 132px;  /* 调整位置，与筛选按钮底部对齐 */
  left: 0;
  width: 35%;
  height: 480px;
  background: white;
  z-index: 1000;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);  /* 添加阴影 */
}

.menu-header {
  text-align: right;
}

.close-btn {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 45px;
  color: #333;
  cursor: pointer;
  transform: translate(-14px, 12px);
}

.menu-list {
  padding: 10px 0;
}

.menu-item {
  padding: 15px 18px;
  font-size: 18px;
  color: #333;
  font-weight: bold;
  font-family: Songti SC, Songti SC;
  transition: all 0.3s ease;
  cursor: pointer;
}

/* 优化全部选项的样式 */
.menu-item:first-child {
  color: #DD8560;
  position: relative;
}

/* 添加分隔线 */
.menu-item:first-child::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #f5f5f5;
}

/* 添加hover效果 */
.menu-item:hover {
  background: #f9f9f9;
  color: #DD8560;
}

/* 移除之前的active样式 */
.menu-item.active {
  display: none;
}

.goods-list {
  padding: 15px;
}

.goods-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.goods-item {
  background: #fff;
  border-radius: 8px;
}

.goods-item img {
  width: 100%;
  /* height: 220px; */
  object-fit: cover;
}
.goods-title {
  font-weight: bold;
  font-family: Songti SC, Songti SC;
  font-size: 15px;
  color: #333;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.goods-price {
  font-size: 22px;
  color: #FD4418;
  font-weight: 500;
  font-family: Songti SC, Songti SC;
  text-align: left;
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
}

.pagination :deep(.van-pagination) {
  width: 70%;
  max-width: 500px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
}

.pagination :deep(.van-pagination__item) {
  min-width: 36px;
  height: 36px;
  margin: 0 4px;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #eee;
  font-size: 14px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination :deep(.van-pagination__prev),
.pagination :deep(.van-pagination__next) {
  min-width: 20px;
  width: 20px;
  height: 36px !important;
  margin: 0 4px;
  padding: 0;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #eee;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination :deep(.van-pagination__item--active) {
  color: #fff;
  background: #333333;
  /* border-color: #82685e; */
}

.pagination :deep(.van-pagination__prev--disabled),
.pagination :deep(.van-pagination__next--disabled) {
  color: #999;
  background: #f5f5f5;
  border-color: #eee;
}

.pagination :deep(.van-icon) {
  font-size: 14px;
}

.rmb{
  font-size: 16px;
  color: #14142B;
  font-weight: 400;
  margin-right: 4px;
  font-family: Songti SC, Songti SC;
}

/* 添加空状态样式 */
.empty-state {
  padding: 40px 0;
  background: #fff;
}

.custom-empty {
  padding: 40px 0;
}

.empty-tip {
  margin-top: 8px;
  color: #999;
  font-size: 14px;
  font-family: Songti SC, Songti SC;
}

/* 修改价格筛选面板样式 */
.price-filter-panel {
  position: fixed;
    top: 132px;
    right: 0;
    width: 100%;
    height: 40%;
    background: #fff;
    z-index: 1000;
    /* box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1); */
}

.price-filter {
  padding: 20px;
}

.price-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.price-header .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-top: 30px
}

.close-btn {
  font-size: 34px;
  color: #333;
  cursor: pointer;
  margin-top: -40px;
}

.custom-price {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.price-input {
    /* flex: 1; */
    width: 40%;
    height: 44px;
    border: 1px solid #ddd;
    background: #fff;
    padding: 0 10px;
    font-size: 14px;
}

.separator {
  color: #333;
  font-size: 16px;
}

.price-ranges {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 20px 0;
}

.range-item {
  height: 44px;
  background: #fff;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
}

.range-item.active {
  border-color: #333;
  color: #333;
}

.price-actions {
  display: flex;
  gap: 10px;
  margin-top: 30px;
}

.reset-btn, .confirm-btn {
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
}

.reset-btn {
  background: #fff;
  border: 1px solid #ddd;
  color: #333;
}

.confirm-btn {
  background: #333;
  color: #fff;
}

/* 移除之前的 van-popup 相关样式 */
.van-popup {
  display: none;
}
</style>